
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/themes/[slug]",
      function () {
        return require("private-next-pages/themes/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/themes/[slug]"])
      });
    }
  